import { __decorate, __param, __metadata } from 'tslib';
import { StateManager } from '../../services/store/state-manager.js';
import { BuiltinUiState } from '../../services/store/builtin-state.js';
import { StopAction } from '../../decorators/param/stop-action.js';
import { UIConfig } from '../../decorators/param/ui-config.js';
import { Middleware } from '../../decorators/class/middleware.js';
import { NetworkManagerWrapper } from './netcheck-instance.js';

/**
 * @public
 */
let NetworkMiddleware = class NetworkMiddleware {
    constructor(store) {
        store.register(BuiltinUiState.IsOnline, this.isOnline());
        NetworkManagerWrapper.getInstance().changeEnd(() => {
            store.update(BuiltinUiState.IsOnline, this.isOnline());
        });
    }
    // shouldDisabled if offline
    use(stop, config) {
        if (!this.isOnline() && config.respectOffline) {
            stop();
            return true;
        }
        return false;
    }
    isOnline() {
        return NetworkManagerWrapper.getInstance().isOnline;
    }
};
__decorate([
    __param(0, StopAction()),
    __param(1, UIConfig()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function, Object]),
    __metadata("design:returntype", void 0)
], NetworkMiddleware.prototype, "use", null);
NetworkMiddleware = __decorate([
    Middleware({
        overridable: true,
    }),
    __metadata("design:paramtypes", [StateManager])
], NetworkMiddleware);

export { NetworkMiddleware };
//# sourceMappingURL=network.middleware.js.map
